export default __webpack_public_path__ + "static/media/sk.3ecfa3b9.jpg";